<template>
  <div>
    <div>
      <h1 class="text-center">Survey</h1>
      <div>
        <List />
      </div>
    </div>
  </div>
</template>

<script>
import List from "./ListSurvey.vue";
export default {
  components: {
    List,
  },
};
</script>
